/**
 * @generated SignedSource<<6a3f17aee55a35e26cdd41cf4d8fe06a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentArticleAtomBase$data = {
  readonly __typename: "Article";
  readonly " $fragmentSpreads": FragmentRefs<"abandonedCartOfferDialogArticle" | "articleHeadlineHeaderFeaturesArticle" | "articleSeoArticle" | "articleShareWidgetArticle" | "bookmarkHeaderFeaturesArticle" | "commentHeaderFeaturesArticle" | "contentShareWidgetContent" | "helpersCheckIsStyleArticle" | "helpersUseSharingUrl" | "hooksContentInterestArticle" | "hooksTrackPageViewArticle" | "hooksUseCurrentArticleIdsArticle" | "hooksUseCurrentArticlePrebidConfigArticle" | "hooksUsePageTargetingArticle" | "onboardingNewsletterSubscriptionArticle" | "sectionHeaderFeaturesArticle" | "shareHeaderFeaturesContent">;
  readonly " $fragmentType": "atomsCurrentArticleAtomBase";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "atomsCurrentArticleAtomBase";
};
export type atomsCurrentArticleAtomBase$key = {
  readonly " $data"?: atomsCurrentArticleAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentArticleAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentArticleAtomBase"
};

(node as any).hash = "5e3bf11f326e95eec1e85ad67a80a11f";

export default node;
